<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex; justify-content: space-between">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input placeholder="accountId" clearable v-model="accountId" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="auditStatus" placeholder="审核状态" clearable size="mini">
                <el-option v-for="item in auditStatusArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="upgrade" placeholder="待升级状态" clearable size="mini">
                <el-option v-for="item in upgradeArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="level" placeholder="交易员级别" clearable size="mini">
                <el-option v-for="item in levelArr" :key="item.level" :label="item.levelName" :value="item.level">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button size="mini" @click="clearFiled">重置</el-button>
          </div>

          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch({ page: 1 })">查询</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="accountId" prop="accountId" />
        <el-table-column prop="" label="是否待升级" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.upgrade ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前跟随人数" prop="currentFollowers" align="center" />
        <el-table-column label="最大跟随人数" prop="followerThreshold" align="center" />
        <el-table-column label="标签Id" prop="labels" align="center" />
        <el-table-column label="交易员类型" prop="levelName" align="center" />
        <el-table-column label="亏损笔数" prop="lossTimes" align="center" />
        <el-table-column label="交易员昵称" prop="nickName" align="center" />
        <el-table-column label="盈利笔数" prop="profitTimes" align="center" />
        <el-table-column label="交易Id" prop="symbols" align="center" />
        <el-table-column label="总分润" prop="totalBenefit" align="center" />
        <!-- <el-table-column label="总权益" prop="totalEquity" align="center" /> -->
        <el-table-column label="总跟随人数" prop="totalFollowers" align="center" />
        <el-table-column label="总收益" prop="totalProfit" align="center" />
        <el-table-column label="总胜率" prop="winRate" align="center" />

        <el-table-column prop="" label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待审核</span>
            <span v-if="scope.row.status == 2">拒绝</span>
            <span v-if="scope.row.status == 1">审核通过</span>
            <span v-if="scope.row.status == 3">已解约</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="mini" @click="show(scope.row)"
              >分析</el-button
            > -->
            <!-- <el-button type="text" size="mini" @click="downLevel(scope.row)"
              >降级</el-button
            > -->
            <el-button v-if="$hasPerm('tenant:copy_trader:update_level')" type="text" size="mini"
              @click="updateLevel(scope.row)">等级调整</el-button>
            <el-button v-if="
              (scope.row.status == 0 || scope.row.upgrade) &&
              $hasPerm('tenant:copy_trader:audit')
            " type="text" size="mini" @click="audit(scope.row)">审核</el-button>
            <el-button v-if="
              scope.row.status == 1 &&
              $hasPerm('tenant:copy_trader:termination')
            " type="text" size="mini" @click="termination(scope.row)">解约</el-button>
            <el-button v-if="$hasPerm('tenant:copy_trader:audit_log')" type="text" size="mini"
              @click="auditLog(scope.row)">审核记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="paginationHandle">
      </pagination>

      <el-dialog title="审核记录" :visible="dialogVisible1" width="800px" @close="closeTabBox" :destroy-on-close="true">
        <div class="modalSearch">
          <!-- <el-input placeholder="id" clearable v-model="id" size="mini">
          </el-input> -->
          <el-select v-model="type" placeholder="审核类型" clearable size="mini">
            <el-option v-for="item in auditType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button size="mini" type="primary" @click="getModalData({ page: 1 })">查询</el-button>
        </div>
        <el-table :data="modalTabList">
          <el-table-column label="审核记录id" prop="id" />
          <el-table-column prop="currentLevel" label="当前级别" />
          <el-table-column label="拒绝原因" prop="reason" />
          <el-table-column label="待升级级别" prop="upgradeLevel" />
          <el-table-column prop="" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待审核</span>
              <span v-if="scope.row.status == 2">拒绝</span>
              <span v-if="scope.row.status == 1">审核通过</span>
              <span v-if="scope.row.status == 3">已解约</span>
            </template>
          </el-table-column>
          <el-table-column label="审核时间" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.auditTime | moment }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <pagination
          :size="modalPagination.size"
          :total="modalTotalCount"
          :page="modalPagination.page"
          @pageChanged="modalPaginationHandle"
        >
        </pagination> -->
      </el-dialog>

      <el-dialog :title="title" :visible="dialogVisible" width="800px" @close="close" :destroy-on-close="true">
        <div class="info">
          <el-descriptions class="margin-top" :column="2">
            <el-descriptions-item label="注册时间">{{
              12312312312 | moment
              }}</el-descriptions-item>
            <el-descriptions-item label="开通跟单时间">{{
              12312312312 | moment
              }}</el-descriptions-item>
            <el-descriptions-item label="用户姓名">苏州市</el-descriptions-item>
            <el-descriptions-item label="KYC类型"> </el-descriptions-item>
            <el-descriptions-item label="合约总权益">江苏省苏州市</el-descriptions-item>
            <el-descriptions-item label="累计跟随人数">江苏省苏州市</el-descriptions-item>
            <el-descriptions-item label="累计跟单交易额">江苏省苏州市</el-descriptions-item>
            <el-descriptions-item label="盈利笔数/带单笔数">江苏省苏州市</el-descriptions-item>
            <el-descriptions-item label="累计分润" :span="2">江苏省苏州市(已分润数据)</el-descriptions-item>
            <el-descriptions-item label="交易员等级" :span="2">明星交易员(10%)<span>设置</span>
            </el-descriptions-item>
          </el-descriptions>

          <el-tabs v-model="activeTab" @tab-click="handleTabChange">
            <el-tab-pane label="当前带单" name="aa"></el-tab-pane>
            <el-tab-pane label="历史带单" name="bb"></el-tab-pane>
            <el-tab-pane label="行为日志" name="cc"></el-tab-pane>
            <el-tab-pane label="风控日志" name="dd"></el-tab-pane>
          </el-tabs>
          <el-table :data="modalTabList">
            <template v-if="activeTab == 'aa'">
              <el-table-column label="带单合约" width="160">
                <template slot-scope="scope">
                  <span>BTC_USDT</span>
                  <span>永续</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓价" prop="takerFee" />
              <el-table-column label="最新价" prop="takerFee" />
              <el-table-column label="开仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓数量" prop="takerFee" />
              <el-table-column prop="" label="未实现盈亏">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
              <el-table-column label="跟单人数" prop="takerFee" />
              <el-table-column label="跟单总量" prop="takerFee" />
            </template>
            <template v-if="activeTab == 'bb'">
              <el-table-column label="带单合约" width="160">
                <template slot-scope="scope">
                  <el-tag>标签一</el-tag>
                  <span>BTC_USDT</span>
                </template>
              </el-table-column>
              <el-table-column label="开仓价" prop="takerFee" />
              <el-table-column label="平仓价" prop="takerFee" />
              <el-table-column label="开仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平仓时间" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平仓数量" prop="takerFee" />
              <el-table-column prop="" label="平仓盈亏">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="带单利润">
                <template slot-scope="scope">
                  <span class="redTxt">{{}}</span>
                  <span class="greenTxt">{{}}</span>
                </template>
              </el-table-column>
              <el-table-column label="跟单人数" prop="takerFee" />
              <el-table-column label="跟单总量" prop="takerFee" />
            </template>

            <template v-if="activeTab == 'cc'">
              <el-table-column label="日志类型">
                <template slot-scope="scope">
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="操作时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
            </template>

            <template v-if="activeTab == 'dd'">
              <el-table-column label="日志类型">
                <template slot-scope="scope">
                  <span>sadasd</span>
                </template>
              </el-table-column>
              <el-table-column label="操作时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdTime | moment }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :size="modalPagination.size" :total="modalTotalCount" :page="modalPagination.page"
            @pageChanged="modalPaginationHandle">
          </pagination>
        </div>
      </el-dialog>

      <el-dialog title="审核" :visible="auditVisible" width="400px" @close="closeAuditModal" :destroy-on-close="true">
        <el-form :model="auditFormData" size="medium" label-width="100px">
          <el-form-item label="审核状态" prop="">
            <el-select v-model="auditFormData.status" placeholder="" clearable>
              <el-option v-for="item in statusArr" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核类型" prop="">
            <el-select v-model="auditFormData.type" placeholder="" clearable>
              <el-option v-for="item in modalTypeArr" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原因" prop="">
            <el-input v-model="auditFormData.reason" class="w300" type="textarea" :rows="2">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeAuditModal">取消</el-button>
          <el-button v-if="$hasPerm('tenant:copy_trader:audit')" type="primary" @click="handleAudit">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="等级调整" :visible="levelAdjustVisible" width="400px" @close="closeLevelAdjustModal"
        :destroy-on-close="true">
        <el-form :model="levelAdjustFormData" size="medium" label-width="100px">
          <el-form-item label="当前等级" prop="">
            <span>{{ levelAdjustFormData.currentLevelName }}</span>
          </el-form-item>
          <el-form-item label="调整等级" prop="levelId" :rules="[{ required: true, message: '请选择等级', trigger: 'change' }]">
            <el-select v-model="levelAdjustFormData.levelId" placeholder="请选择等级" clearable>
              <el-option v-for="item in levelArr" :key="item.level" :label="item.levelName" :value="item.level"
                :disabled="String(item.level) === String(levelAdjustFormData.currentLevel)"
                v-if="item.level !== ''"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeLevelAdjustModal">取消</el-button>
          <el-button v-if="$hasPerm('tenant:copy_trader:update_level')" type="primary"
            @click="handleLevelAdjust">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      modalTabList: [],
      modalTotalCount: 0,
      modalPagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "",
      dialogVisible1: false,
      auditVisible: false,
      levelAdjustVisible: false,
      formData: {
        tabData: [],
        title: "",
        info: {},
      },
      statusArr: [
        { label: "审核通过", value: "1" },
        { label: "审核拒绝", value: "2" },
      ],
      modalTypeArr: [
        { label: "申请交易员", value: "1" },
        { label: "交易员等级升级", value: "2" },
      ],
      auditStatusArr: [
        { label: "全部状态", value: "" },
        { label: "待审核", value: "0" },
        { label: "通过", value: "1" },
        { label: "拒绝", value: "2" },
        { label: "已解约", value: "3" },
      ],
      levelArr: [],
      upgradeArr: [
        { label: "全部", value: "" },
        { label: "代升级", value: "1" },
        // { label: "无", value: "2" },
      ],
      type: "1",
      auditType: [
        // { label: "全部", value: "" },
        { label: "申请交易员", value: "1" },
        { label: "交易员等级升级", value: "2" },
      ],
      level: "",
      upgrade: "",
      accountId: "",
      auditStatus: "",
      activeTab: "aa",
      rowId: "",
      auditFormData: {
        id: "",
        reason: "",
        status: "1",
        type: "1",
      },
      levelAdjustFormData: {
        id: "",
        levelId: "",
        currentLevelName: "",
        currentLevel: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.handleSearch();
    api.copytradeLevelList().then((res) => {
      if (res.code == 0) {
        this.levelArr = [{ levelName: "全部", level: "" }, ...res.data];
      }
    });
  },
  methods: {
    clearFiled() {
      this.accountId = "";
      this.auditStatus = "";
      this.upgrade = "";
      this.level = "";
      this.handleSearch({ page: 1 });
    },
    handleSearch(data = {}) {
      api
        .copytradeLeaderList({
          level: this.level,
          upgrade: this.upgrade,
          accountId: this.accountId,
          auditStatus: this.auditStatus,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { total, items } = res.data;
            this.tabList = items;
            this.totalCount = total;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(row) {
      // if (row) {
      //   this.formData = JSON.parse(JSON.stringify(row));
      //   this.formData.createdTime = undefined;
      //   this.formData.updatedTime = undefined;
      // }
      this.formData = { tabData: [], title: "", info: {} };
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = { tabData: [], title: "", info: {} };
    },

    auditLog(row) {
      this.dialogVisible1 = true;
      this.rowId = row.id;
      this.getModalData();
    },
    getModalData(data = {}) {
      api.copytradeAuditLog({ id: this.rowId, type: this.type }).then((res) => {
        if (res.code == 0) {
          this.modalTabList = res.data;
        }
      });
    },
    closeTabBox() {
      this.dialogVisible1 = false;
      this.rowId = "";
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
    },
    modalPaginationHandle(pagination) {
      this.modalPagination = pagination;
      this.getModalData();
    },
    handleTabChange(tab) {
      this.modalTabList = [];
      this.modalTotalCount = 0;
      this.modalPagination = {
        page: 1,
        size: 25,
      };
      this.getCopyModalTabData();
    },
    getCopyModalTabData() {
      console.log("2222", 2222);
      // ...modalPagination
    },

    downLevel(row) {
      this.$confirm("你确定将交易员降级？", "提示", {
        type: "warning",
      }).then(() => {
        api.copytradeLeaderDowngrading({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功！");
            this.handleSearch();
          }
        });
      });
    },
    updateLevel(row) {
      this.levelAdjustVisible = true;
      this.levelAdjustFormData.id = row.id;
      this.levelAdjustFormData.currentLevelName = row.levelName || "未知等级";
      this.levelAdjustFormData.currentLevel = String(row.levelId || "");
      this.levelAdjustFormData.levelId = "";
      console.log("当前等级:", this.levelAdjustFormData.currentLevel, "类型:", typeof this.levelAdjustFormData.currentLevel);
    },
    termination(row) {
      this.$confirm("你确定将交易员解约？", "提示", {
        type: "warning",
      }).then(() => {
        api.copytradeLeaderTermination({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功！");
            this.handleSearch();
          }
        });
      });
    },

    audit(row) {
      this.auditVisible = true;
      this.auditFormData.id = row.id;
      if (row.upgrade) {
        this.auditFormData.type = "2";
      } else {
        this.auditFormData.type = "1";
      }
    },
    closeAuditModal() {
      this.auditVisible = false;
      this.auditFormData = {
        id: "",
        reason: "",
        status: "1",
        type: "1",
      };
    },
    handleAudit() {
      console.log("this.auditFormData", this.auditFormData);
      api.copytradeLeaderAudit(this.auditFormData).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.closeAuditModal();
          this.handleSearch();
        }
      });
    },

    // 关闭等级调整弹窗
    closeLevelAdjustModal() {
      this.levelAdjustVisible = false;
      this.levelAdjustFormData = {
        id: "",
        levelId: "",
        currentLevelName: "",
        currentLevel: "",
      };
    },

    // 处理等级调整
    handleLevelAdjust() {
      if (!this.levelAdjustFormData.levelId) {
        this.$message.warning("请选择要调整的等级");
        return;
      }

      const params = {
        id: this.levelAdjustFormData.id,
        levelId: this.levelAdjustFormData.levelId,
      };

      this.$confirm("确定要调整该交易员的等级吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.setLeaderLevel(params).then((res) => {
          if (res.code == 0) {
            this.$message.success("等级调整成功！");
            this.closeLevelAdjustModal();
            this.handleSearch();
          } else {
            this.$message.error(res.message || "等级调整失败");
          }
        }).catch((error) => {
          this.$message.error("等级调整失败，请重试");
          console.error("等级调整失败:", error);
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.buleTxt {
  color: blue;
  cursor: pointer;
  user-select: none;
}

.modalSearch {
  display: flex;
  gap: 20px;

  .el-input {
    width: 200px;
  }
}

.greenTxt {
  color: #409eff;
}

.redTxt {
  color: red;
}
</style>
